
import {
  hasError,
  hideSufix,
  placeholder,
  hasLocalizedLabels,
  options,
  selectClasses,
  textClasses,
  isDisabled,
  iconClasses,
  initialSelected,
  isRelative,
} from './props'
import Icon from '~/components/atoms/icon/index.vue'

export default {
  components: {
    Icon,
  },
  props: {
    hasError,
    hideSufix,
    placeholder,
    hasLocalizedLabels,
    options,
    selectClasses,
    textClasses,
    isDisabled,
    iconClasses,
    initialSelected,
    isRelative,
  },
  data() {
    return {
      selected: this.initialSelected,
      showMenu: false,
    }
  },

  methods: {
    onClickItem(option, event) {
      event.stopPropagation()
      this.selected = option
      this.showMenu = false
      this.$emit('select', option, { fromMobile: false })
    },
    onClick(event) {
      event.stopPropagation()
      this.$emit('toggle')

      this.showMenu = !this.showMenu
    },
    onClickOutside() {
      this.showMenu = false
      this.$emit('select:hide-options')
    },
    localizeLabel(label) {
      return this.hasLocalizedLabels ? this.$t(label) : label
    },
  },
}
